import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"

const PostCard = ({ node }) => {
  return (
    <li className="p-postList__item">
      <Link to={`/companies/${node.fields.slug}/`} className="p-postList__link">
        <div className="p-postList__thumb c-postThumb">
          <figure className="c-postThumb__figure">
            {node.featuredImage.childImageSharp.gatsbyImageData ? (
              <GatsbyImage
                image={node.featuredImage.childImageSharp.gatsbyImageData}
                className="c-postThumb__img"
                objectPosition="top 50%"
                alt={node.frontmatter.title}
              />
            ) : (
              <StaticImage
                src="../images/noimg.png"
                className="c-postThumb__img"
                objectPosition="top 50%"
                alt="No image"
                placeholder="blurred"
                width={640}
                height={640}
              />
            )}
          </figure>
        </div>
        <div className="p-postList__body">
          <h3 className="p-postList__title">{node.frontmatter.title}</h3>
          <div className="p-rating">
            <div className="p-rating_avarage">
              {node.comments.length > 0 && (
                <span
                  className="p-rating_avarage-stars"
                  style={{
                    width:
                      (node.comments.reduce((sum, i) => sum + i.rating, 0) /
                        node.comments.length) *
                        20 +
                      "%",
                  }}
                />
              )}
            </div>
            <span className="p-rating_avarage-num">
              {node.comments.length}
              レビュー
            </span>
          </div>
        </div>
      </Link>
    </li>
  )
}

export default PostCard
